export const PROFILE_ME_REQUEST = "PROFILE_ME_REQUEST";
export const PROFILE_ME_RECEIVE = "PROFILE_ME_RECEIVE";
export const PROFILE_ME_FAILURE = "PROFILE_ME_FAILURE";
export const RESET_PROFILE_ME = "RESET_PROFILE_ME";
